import React, {useState} from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, useTheme } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { IClaimInsertionForm } from "../../models/models";
import { FormAutocomplete } from "../../common/form-fields-wrappers";
import { BY_LEGAL_RAPRESENTATIVE_LIST, CLAIM_TYPES, PRIORITY_LIST, REQUISTER_TYPE_LIST } from "../config";
import FormTextField from "../../common/form-fields-wrappers/FormTextField";
import { ALL_COUNTRIES_PREFIX } from "../../data";

const ClaimInsertionInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const claimInsertionForm = useFormContext<IClaimInsertionForm>();

    // FIXME: mock
    const priorityList = PRIORITY_LIST;
    const claimTypeList = CLAIM_TYPES;
    const byLegalRepresentativeList = BY_LEGAL_RAPRESENTATIVE_LIST;
    const requesterTypeList = REQUISTER_TYPE_LIST;
    const countriesPrefix = ALL_COUNTRIES_PREFIX;

    const [accordion, setAccordion] = useState(true);

    const handleAccordionOnChange = (e: React.SyntheticEvent, expanded: boolean) => {
        e.stopPropagation();

        setAccordion(expanded);
    }

    return (
        <Accordion expanded={accordion} onChange={(e, expanded) => handleAccordionOnChange(e, expanded)}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"h6"}>
                    {t("claimInsertion.claimInsertionInfo.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IClaimInsertionForm>
                            name='claimInsertionInfo.priority'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionInfo.form.label.priority")}
                            fullWidth
                            options={priorityList}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IClaimInsertionForm>
                            name='claimInsertionInfo.type'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionInfo.form.label.type")}
                            fullWidth
                            options={claimTypeList}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionInfo.claimNotes'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionInfo.form.label.claimNotes")}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IClaimInsertionForm>
                            name='claimInsertionInfo.byLegalRepresentative'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionInfo.form.label.legalRapresentative")}
                            fullWidth
                            options={byLegalRepresentativeList}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionInfo.email'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionInfo.form.label.email")}
                        />
                    </Grid>

                    <Grid container item xs={6} md={3} columnSpacing={2}>
                        <Grid item xs={6} sx={{display: "flex", alignItems: "center"}}>
                            <FormAutocomplete<IClaimInsertionForm>
                                name='claimInsertionInfo.prefix'
                                control={claimInsertionForm.control}
                                label={t("claimInsertion.claimInsertionInfo.form.label.prefix")}
                                fullWidth
                                options={countriesPrefix}
                                isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                                getOptionLabel={(option) => option?.code + " +" + option?.description}
                                renderOption= {(props, option) => {
                                    return (
                                        <Box component="li"
                                            {...props}
                                        >
                                            {option?.code} + {option?.description}
                                        </Box>
                                    )}
                                }
                            />
                        </Grid>
                        <Grid item xs={6} sx={{display: "flex", alignItems: "center"}}>
                            <FormTextField<IClaimInsertionForm>
                                name='claimInsertionInfo.phone'
                                control={claimInsertionForm.control}
                                label={t("claimInsertion.claimInsertionInfo.form.label.phone")}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IClaimInsertionForm>
                            name='claimInsertionInfo.requesterType'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionInfo.form.label.requesterType")}
                            fullWidth
                            options={requesterTypeList}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionInfo.requesterNotes'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionInfo.form.label.requesterNotes")}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default ClaimInsertionInfo;